export const ORDER_GROUPING_TYPE = {
    NORMAL: 0,
    NESTING: 1,
    BACKFLUSH: 2
};

export const ALLOCATION_TYPE = {
    NONE: 0,
    PLANNED_QUANTITY: 1,
    PERCENTAGE: 2,
    FIXED_QUANTITY: 3
};

export const GROUPING_STATUS = {
    WAITING: 0,
    IN_PROGRESS: 1,
    FINISHED: 2,
    CANCELLED: 3
};

const unwrap = response => response.data.data;

export default http => ({
    async list(params) {
        return unwrap(await http.get("/api/mysfc/order-groupings", { params }));
    },
    async get(id) {
        return unwrap(await http.get(`/api/mysfc/order-groupings/${id}`));
    },
    async availableOrders(params) {
        return unwrap(
            await http.get("/api/mysfc/order-groupings/available-orders", { params })
        );
    },
    async create(payload) {
        return unwrap(await http.post("/api/mysfc/order-groupings", payload));
    },
    async update(id, payload) {
        return unwrap(await http.put(`/api/mysfc/order-groupings/${id}`, payload));
    },
    async backflush(id, payload) {
        return unwrap(await http.post(`/api/mysfc/order-groupings/${id}/backflush`, payload));
    },
    async cancel(id) {
        return unwrap(await http.post(`/api/mysfc/order-groupings/${id}/cancel`));
    },
    async setup(id, payload = {}) {
        return unwrap(await http.post(`/api/mysfc/order-groupings/${id}/setup`, payload));
    },
    async start(id, payload = {}) {
        return unwrap(await http.post(`/api/mysfc/order-groupings/${id}/start`, payload));
    },
    async stop(id, payload) {
        return unwrap(await http.post(`/api/mysfc/order-groupings/${id}/stop`, payload));
    },
    async finish(id, payload) {
        return unwrap(await http.post(`/api/mysfc/order-groupings/${id}/finish`, payload));
    },
    async delete(id) {
        return unwrap(await http.delete(`/api/mysfc/order-groupings/${id}`));
    },
    async createAppointment(id, payload) {
        return unwrap(
            await http.post(`/api/mysfc/order-groupings/${id}/appointments`, payload)
        );
    },
    async appointments(id) {
        return unwrap(await http.get(`/api/mysfc/order-groupings/${id}/appointments`));
    },
    async deleteAppointment(id, appointmentId) {
        return unwrap(
            await http.delete(`/api/mysfc/order-groupings/${id}/appointments/${appointmentId}`)
        );
    },
    async appointmentContext(siteId, resourceId) {
        return unwrap(
            await http.get("/api/mysfc/operation-progress/context", { params: { siteId, resourceId } })
        );
    }
});
